var map = {
	"./EngramLogo(old).png": 5397,
	"./EngramLogo.png": 6054,
	"./EngramLogo_bkground.png": 5549,
	"./Essay.svg": 1931,
	"./FirstGlobalAge.png": 9779,
	"./Modern.png": 5846,
	"./RegionalInteractions.png": 8463,
	"./Rev&Indus.png": 2437,
	"./book.svg": 3096,
	"./css/about.sass": 6476,
	"./css/design-system/_animations.sass": 7317,
	"./css/design-system/_buttons.sass": 3001,
	"./css/design-system/_components.sass": 8866,
	"./css/design-system/_forms.sass": 4042,
	"./css/design-system/_tokens.sass": 7795,
	"./css/design-system/_typography.sass": 7168,
	"./css/design-system/_utilities.sass": 2976,
	"./css/design-system/index.sass": 9319,
	"./css/essayWriting.sass": 359,
	"./css/essayWritingView.sass": 554,
	"./css/eventsExplorer.sass": 2167,
	"./css/feedback.sass": 8240,
	"./css/home.sass": 1751,
	"./css/labelSection.sass": 6869,
	"./css/leq.sass": 4829,
	"./css/loading.sass": 8517,
	"./css/main.sass": 7595,
	"./css/masterStyles.sass": 3436,
	"./css/navbar.sass": 3392,
	"./css/quiz.sass": 7149,
	"./css/resources.sass": 2255,
	"./css/selectModule.sass": 1022,
	"./css/topicContent.sass": 4589,
	"./css/topicEvents.sass": 392,
	"./css/topics.sass": 4934,
	"./css/units.sass": 3796,
	"./eyes.png": 9856,
	"./globe2.jpg": 7950,
	"./writing_feature/Ellipse 108.svg": 3313,
	"./writing_feature/Ellipse 109.svg": 880,
	"./writing_feature/Ellipse 110.svg": 9097,
	"./writing_feature/Ellipse 111.svg": 6577,
	"./writing_feature/Ellipse 112.svg": 2750,
	"./writing_feature/IconGroup.svg": 3759,
	"./writing_feature/IconGroup2.svg": 7321,
	"./writing_feature/IconGroup3.svg": 6387,
	"./writing_feature/IcongroupFinal.svg": 2528,
	"./writing_feature/ModuleIcon.svg": 9598,
	"./writing_feature/ModuleIcon0.svg": 650,
	"./writing_feature/ModuleIcon2.svg": 9601,
	"./writing_feature/ModuleIcon3.svg": 9218,
	"./writing_feature/ModuleIcon4.svg": 7133,
	"./writing_feature/Polygon 1.svg": 249,
	"./writing_feature/PurpleCircle.svg": 5801,
	"./writing_feature/books.gif": 7114,
	"./writing_feature/chevron-down-gray.svg": 1651,
	"./writing_feature/chevron-down.svg": 1959,
	"./writing_feature/chevron-left.svg": 2840,
	"./writing_feature/chevron-right-purple.svg": 150,
	"./writing_feature/chevron-right.svg": 8266,
	"./writing_feature/chevron-up-gray.svg": 810,
	"./writing_feature/demo.svg": 2640,
	"./writing_feature/demov2.png": 7433,
	"./writing_feature/expand_less.svg": 3633,
	"./writing_feature/expand_more.svg": 3378,
	"./writing_feature/media1.svg": 8142,
	"./writing_feature/media2.svg": 4866,
	"./writing_feature/plus.svg": 6182,
	"./writing_feature/refresh.svg": 7279,
	"./writing_feature/right-arrow.svg": 3964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;